// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BugReportIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BugReportIcon" ref={forwardedRef} {...props}>
      <path d="M5.75 7.25a4.25 4.25 0 0 1 8.5 0v.018L16.098 6.2l.75 1.299L14.25 9v1.5H17V12h-2.757a4.2 4.2 0 0 1-.295 1.326l2.113 2.113L15 16.499l-1.872-1.872A4.24 4.24 0 0 1 10 16a4.24 4.24 0 0 1-3.128-1.372L5 16.5l-1.06-1.06 2.112-2.113A4.2 4.2 0 0 1 5.757 12H3v-1.5h2.75V8.992L3.25 7.55 4 6.25l1.75 1.01zm7 1.25h-5.5v3.25a2.75 2.75 0 1 0 5.5 0zM12.739 7A2.75 2.75 0 0 0 7.26 7z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BugReportIcon = /* @__PURE__ */ Object.assign(
  BugReportIconComponent,
  { displayName: 'BugReportIcon' },
);
